import { connect } from 'react-redux';

import ComponentWrapper from './components/ComponentWrapper';
import LoginHOC from '../../../../components/LoginHOC';

const mapStateToProps = (state) => ({
  authenticatedID: (state.auth.sub || null),
  authedUser: state.auth,
});

export default (store) => ({
  path : 'component/:id',
  component: LoginHOC(connect(mapStateToProps)(ComponentWrapper)),
});



// WEBPACK FOOTER //
// ./src/routes/modules/routes/ViewComponent/index.js